import React, { Fragment } from "react";
import CauseCard from "./widgets/CauseCard";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const OpenCauses = (props) => {
  const { t } = useTranslation();

  const openCauses = useSelector((state) => state.main.open_causes);

  return (
    <Fragment>
      <section
        ref={props.sectionRef}
        className="page-section bg-light card-saa open-causes-area"
      >
        <div className="container" style={{
          minHeight: "690px"
        }}>
          <h2 className="text-center mt-0">{t("OPEN_CAUSES_HEADER_LABEL")}</h2>
          <hr className="divider my-4" />
          <div className="row justify-content-center">
            {openCauses.map((cause, index) => (
              <CauseCard key={index} cause={cause} />
            ))}
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default OpenCauses;
